module.exports = __webpack_public_path__ + "src/img/artist/work03_1.jpg?c63b087c9781d8150a151da882c0b443";


//////////////////
// WEBPACK FOOTER
// ./src/img/artist/work03_1.jpg
// module id = 20
// module chunks = 0